import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../constants';
import * as D from '../../deps';

const ArtistSubtitleSmall = props => {
  const { albumCount } = props;
  const abbreviatedAlbumCount = D.numberToHumanSize(albumCount);

  return (
    <span>
      {abbreviatedAlbumCount}{' '}
      <FormattedMessage {...BackstageConstants.messages.albums} values={{ albumCount }} />
    </span>
  );
};

ArtistSubtitleSmall.propTypes = {
  albumCount: PropTypes.number,
};

export default ArtistSubtitleSmall;
